import { memoizedFetchSitePersonalization } from '@atlassian/jira-personalization-service/src/services/site/index.tsx';

export const isSiteOptedOut = async (cloudId: string) => {
	const siteTraits = await memoizedFetchSitePersonalization({ cloudId });
	const optoutTraitValue = siteTraits.find((trait) => trait.name === 'optout_all_messages')?.value;
	return typeof optoutTraitValue === 'boolean' && optoutTraitValue;
};
